import { forwardRef } from 'react';

import type { ForwardRefRenderFunction, HTMLAttributes } from 'react';

export type InputFieldNoteProps = Omit<
  HTMLAttributes<HTMLDivElement>,
  'className'
>;

const InputFieldNoteRenderFunction: ForwardRefRenderFunction<
  HTMLDivElement,
  InputFieldNoteProps
> = (attrs, ref) => {
  return (
    <div {...attrs} ref={ref} className="text-sm text-marine-medium-emphasis" />
  );
};

export const InputFieldNote = forwardRef<HTMLDivElement, InputFieldNoteProps>(
  InputFieldNoteRenderFunction,
);
